/** The referral link's path. */
export const matePath = (alias: string) => `/mate/${alias}`;
